<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Unternehmensgruppe</p>

      <h2 class="presentation-page__title">Eingebettet in eine starke Gruppe</h2>

      <p class="presentation-page__text">
        Stabile Konzernstruktur und Finanzierungssicherheit — wesentlich für 20+ Jahre
        Anlagenlaufzeit.
      </p>

      <div class="presentation-page__group-cards">
        <article
          v-for="groupCard in groupCards"
          :key="groupCard.title"
          class="presentation-page__group-card"
        >
          <div
            :class="[
              'presentation-page__group-card-header',
              `presentation-page__group-card-header--${groupCard.accent}`,
            ]"
          >
            {{ groupCard.header }}
          </div>

          <div class="presentation-page__group-card-body">
            <div
              :class="[
                'presentation-page__group-card-icon',
                `presentation-page__group-card-icon--${groupCard.accent}`,
              ]"
              aria-hidden="true"
            >
              <i :class="['fa', groupCard.icon]"></i>
            </div>

            <h3 class="presentation-page__group-card-title">{{ groupCard.title }}</h3>

            <div
              v-if="groupCard.hasAccent"
              class="presentation-page__group-card-accent"
              aria-hidden="true"
            ></div>

            <p class="presentation-page__group-card-text">{{ groupCard.text }}</p>
          </div>
        </article>
      </div>

      <p class="presentation-page__caption">
        Eine PV-Anlage, die 20+ Jahre laufen muss, braucht einen Partner, der 20+ Jahre besteht.
      </p>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage05',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      groupCards: [
        {
          header: 'Operative Ebene',
          accent: 'brand-teal',
          icon: 'fa-sun-o',
          title: 'e way Energy GmbH',
          hasAccent: true,
          text: 'EPC- und O&M-Partner. Plant, baut und betreibt PV-Anlagen schlüsselfertig.',
        },
        {
          header: 'Muttergesellschaft',
          accent: 'brand-secondary',
          icon: 'fa-building',
          title: 'Salvia Gebäudetechnik',
          hasAccent: true,
          text: 'Eine der führenden Gebäudetechnik-Gruppen im deutschsprachigen Raum.',
        },
        {
          header: 'Konzern',
          accent: 'brand-primary',
          icon: 'fa-university',
          title: 'Eiffage-Gruppe',
          hasAccent: true,
          text: 'Börsennotierter französischer Bau- und Konzessionskonzern. ~78.200 Mitarbeiter.',
        },
      ],
    };
  },
};
</script>
